import Vue from 'vue';
import Router from 'vue-router';
import Layout from './views/Layout';
import Admin from './views/adminPortal/Layout';
import webRoutes from './routes/web';
import adminRoutes from './routes/admin';
import NProgress from 'nprogress';
import { ROUTER_NAMES } from './constants';
import routerChecks from './utils/routeChecks';
import store from './store';
import {wait} from './main';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: ROUTER_NAMES.INDEX,
      component: Layout,
      redirect: ROUTER_NAMES.HOME,
      children: webRoutes
    },
    {
      path: '/admin',
      name: ROUTER_NAMES.ADMIN_INDEX,
      component: Admin,
      redirect: '/admin/events',
      children: adminRoutes,
      beforeEnter: (to, from, next) => {
        routerChecks.onlyAdmin(next);
      }
    },
    {
      path: '/error',
      name: ROUTER_NAMES.ERROR,
      components: {
        default: () => import('./views/errors/Error.vue')
      }
    },
    {
      name: ROUTER_NAMES.NOT_FOUND,
      path: '*',
      components: {
        default: () => import('./views/errors/NotFound.vue')
      }
    }
  ],
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  // Load menu if is not loaded
  wait.start('load menu');
  store.dispatch('loadPages')
    .then(() => {
      wait.end('load menu');
    });
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
